// components/BdiItem.tsx
"use client";

import React from "react";
import { Item } from "../../data/questionnairesData";

interface BdiItemProps {
  item: Item;
  selectedOptionIndex: number | null; // Null means not selected, stores the index (0, 1, 2...)
  onSelect: (optionIndex: number) => void; // Callback receives the selected option's index
  language: "en" | "zh";
}

const BdiItem: React.FC<BdiItemProps> = ({
  item,
  selectedOptionIndex,
  onSelect,
  language,
}) => {
  if (!item) {
    return null; // Or render a fallback message
  }
  return (
    <div className="mb-6 p-4 border rounded-lg shadow-sm bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-400">
      <h3 className="text-lg font-semibold mb-3 text-cyan-700 dark:text-cyan-500">
        {item.id}. {item[language]}
      </h3>
      <div className="space-y-2">
        {item.options.map((option, optionIndex) => (
          <div key={optionIndex} className="flex items-start">
            <input
              type="radio"
              id={`item-${item.id}-option-${optionIndex}`}
              name={`item-${item.id}`} // Group radio buttons by item ID
              value={optionIndex} // <<< Use the option index as the unique value
              checked={selectedOptionIndex === optionIndex} // <<< Check based on selected index
              onChange={(e) => onSelect(parseInt(e.target.value, 10))} // <<< Parse value (option index) to number and pass
              className="mt-1 mr-2 form-radio text-blue-600"
            />
            <label
              htmlFor={`item-${item.id}-option-${optionIndex}`}
              className="text-gray-700 dark:text-gray-100 cursor-pointer flex-1"
            >
              {option[language]} {/* Display the option text */}
              {/* Optionally display score for debugging: ({option.score}) */}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BdiItem;
